import { csvParse } from "d3-dsv"
import { funnelize } from "../../components"

export const temperature_data = `year,January,February,March,April,May,June,July,August,September,October,November,December,Annual
1977,22.1,33.5,46.8,53.7,65.0,70.2,79.0,75.7,68.2,54.9,47.3,35.7,54.3
1978,28.0,27.2,39.0,51.6,61.5,71.3,74.4,76.0,65.0,54.9,47.8,38.9,53.0
1979,33.6,25.5,46.9,52.6,65.3,69.2,76.9,76.8,70.5,57.3,52.5,41.1,55.7
1980,33.7,31.4,41.2,54.5,65.6,70.3,79.3,80.3,70.8,55.2,44.6,32.5,55.0
1981,26.3,39.3,42.3,56.2,64.8,73.0,78.5,76.0,67.6,54.4,47.7,36.5,55.2
1982,26.1,35.3,42.0,51.2,64.1,68.6,77.9,73.2,68.3,58.5,50.4,42.8,54.9
1983,34.5,36.4,44.0,52.3,60.2,73.4,79.5,77.7,71.8,57.9,48.9,35.2,56.0
1984,29.9,40.6,36.7,51.9,61.6,74.5,74.7,76.7,65.9,61.8,47.3,43.8,55.5
1985,28.8,36.6,45.8,55.5,65.3,68.6,76.2,75.4,70.5,59.5,50.0,34.2,55.5
1986,34.1,32.0,45.1,54.5,66.0,71.6,76.0,73.1,67.9,58.0,45.7,39.0,55.3
1987,32.3,33.2,45.2,53.4,63.6,72.8,78.0,74.2,67.9,53.8,47.7,39.5,55.1
1988,29.5,35.0,43.6,51.2,62.7,71.8,79.3,78.8,67.4,52.8,49.4,35.9,54.8
1989,37.4,34.5,42.4,52.2,62.1,72.0,75.0,74.0,68.1,58.2,45.7,25.9,54.0
1990,41.4,39.8,45.1,53.5,60.2,72.1,76.8,75.3,67.5,61.9,50.4,42.6,57.2
1991,34.9,40.0,44.6,55.7,68.7,74.1,77.7,77.1,67.5,58.4,48.3,39.6,57.2
1992,35.7,36.4,40.0,50.5,61.0,70.3,74.2,73.0,67.2,54.5,46.5,37.9,53.9
1993,36.3,30.8,39.7,53.3,65.7,73.3,80.2,77.2,67.3,56.0,48.8,37.3,55.5
1994,25.6,30.6,40.7,55.6,61.8,75.2,79.4,74.0,67.6,58.0,52.0,42.2,55.2
1995,37.5,31.6,45.0,51.9,61.9,71.8,79.2,78.6,68.3,61.6,43.6,32.4,55.3
1996,30.5,33.9,38.9,52.2,61.1,71.4,73.4,74.5,68.0,56.4,43.0,41.3,53.7
1997,32.2,40.0,41.9,51.7,59.4,70.9,75.8,73.3,67.0,56.8,44.5,38.3,54.3
1998,40.0,40.6,45.4,54.0,64.3,69.2,76.5,76.7,70.2,57.6,48.1,43.2,57.2
1999,33.9,38.9,42.5,53.5,63.1,73.2,81.4,75.5,69.1,56.0,50.6,40.0,56.5
2000,31.3,37.3,47.2,51.0,63.5,71.3,72.3,72.7,66.0,57.0,45.3,31.1,53.9
2001,33.6,35.9,39.6,54.2,63.8,72.9,73.2,78.7,67.7,58.5,52.7,44.1,56.3
2002,39.9,40.6,44.1,56.1,60.7,71.4,78.8,77.7,70.2,55.2,46.0,36.0,56.4
2003,27.5,30.1,43.1,49.8,58.7,68.3,75.8,76.7,67.9,55.1,50.0,37.6,53.4
2004,24.7,35.0,43.5,53.6,65.2,71.2,74.5,74.2,69.3,56.0,48.2,38.4,54.5
2005,31.3,36.5,39.4,55.1,59.8,74.0,77.5,79.7,73.3,57.9,49.6,35.3,55.8
2006,40.9,35.7,43.1,55.7,63.1,71.0,77.9,75.8,66.6,56.2,51.9,43.6,56.8
2007,37.5,28.2,42.2,50.3,65.2,71.4,75.0,74.0,70.3,63.6,45.4,37.0,55.0
2008,36.5,35.8,42.6,54.9,60.1,74.0,78.4,73.8,68.8,55.1,45.8,38.1,55.3
2009,27.9,36.7,42.4,54.5,62.5,67.5,72.7,75.7,66.3,55.0,51.2,35.9,54.0
2010,32.5,33.1,48.2,57.9,65.3,74.7,81.3,77.4,71.1,58.1,47.9,32.8,56.7
2011,29.7,36.0,42.3,54.3,64.5,72.3,80.2,75.3,70.0,57.1,51.9,43.3,56.4
2012,37.3,40.9,50.9,54.8,65.1,71.0,78.8,76.7,68.8,58.0,43.9,41.5,57.3
2013,35.1,33.9,40.1,53.0,62.8,72.7,79.8,74.6,67.9,60.2,45.3,38.5,55.3
2014,28.6,31.6,37.7,52.3,64.0,72.5,76.1,74.5,69.7,59.6,45.3,40.5,54.4
2015,29.9,23.9,38.1,54.3,68.5,71.2,78.8,79.0,74.5,58.0,52.8,50.8,56.7
2016,34.5,37.7,48.9,53.3,62.8,72.3,78.7,79.2,71.8,58.8,49.8,38.3,57.2`

const processedNYCTemp = csvParse(temperature_data)

processedNYCTemp.forEach(d => {
  Object.keys(d).forEach(key => {
    d[key] = key === "year" ? d[key] : parseFloat(d[key])
  })
})

export const xyframe_data = processedNYCTemp

export const orframe_data = funnelize({
  data: xyframe_data,
  steps: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
    "Annual"
  ],
  key: "year"
})
